import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MultiYearAgreement, MyaProjectCandidate } from '@app-shared/interfaces/multi-year-agreement/multi-year-agreement';
import { Observable } from 'rxjs';
import { MultiYearAgreementResponse } from '../interfaces/multi-year-agreement/multi-year-agreement';


@Injectable({
  providedIn: 'root'
})
export class MultiYearAgreementService {

  constructor(private http: HttpClient) {}

  //Get multi-year agreements
  getMultiYearAgreements(params:any): Observable<MultiYearAgreementResponse> {
    return this.http.get<MultiYearAgreementResponse>(`/multiYearAgreements`, { params });
  }

  //Get multi-year agreement by ID
  getMultiYearAgreementById(multiYearAgreementId: string): Observable<MultiYearAgreement> {
    return this.http.get<MultiYearAgreement>(`/multiYearAgreements/${multiYearAgreementId}`);
  }

  //Update multi-year agreement
  updateMultiYearAgreement(myaId: string, multiYearAgreement: any): Observable<any> {
    return this.http.put<any>(`/multiYearAgreements/${myaId}`, multiYearAgreement);
  }

  //Delete multi-year agreement
  deleteMultiYearAgreement(multiYearAgreementId: string): Observable<any> {
    return this.http.delete<any>(`/multiYearAgreements/${multiYearAgreementId}`);
  }

  // Get Distinct Column Values
  getDistinctColumnValues(params: any): Observable<string[]> {
    return this.http.get<string[]>(`/multiYearAgreements/distinctColumnValues`, { params });
  }


  getMyaProjectsByMyaId(myaId: string, term?: string): Observable<MyaProjectCandidate[]> {
    let endpoint = `/multiYearAgreements/projects/${myaId}`;
    if (term) {
      endpoint += `?searchTerm=${term}`;
    }
    return this.http.get<MyaProjectCandidate[]>(endpoint);
  }


  // Remove multi-year project
  removeMultiYearProject(myaId: string, projectId: string): Observable<any> {
    return this.http.delete<any>(`/multiYearAgreements/${myaId}/projects/${projectId}`);
  }

  // Add new multi-Year Agreement
  addNewMultiYearAgreement(multiYearAgreement: any): Observable<string> {
    return this.http.post<string>(`/multiYearAgreements`, multiYearAgreement);
  }

  // Add project to multi-year agreement
  addProjectToMya(multiYearAgreement: any): Observable<any> {
    return this.http.post<any>(`/multiYearAgreements/${multiYearAgreement.myaId}/assignProject`, multiYearAgreement);
  }

  //Get multi-year agreements by site id
  getMultiYearAgreementsBySiteId(siteId: string): Observable<MultiYearAgreement[]> {
    return this.http.get<MultiYearAgreement[]>(`/multiYearAgreements/site/${siteId}`, { });
  }

  // Add next MYA project
  addNextMyaProject(project: any): Observable<string> {
    return this.http.post<string>(`/multiYearAgreements/generateNextMYAProject`, project);
  }

  getMultiYearOptions() {
        return this.http.get<any>(`/multiYearAgreements/getMultiOptions`);
  }

}
